import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';

export interface DataCategory {
  id: string;
  label: string;
  color?: string;
  valueType?: 'number' | 'timestamp' | 'minutes';
  questionType?: string;
}

@Component({
  selector: 'app-data-category-chips',
  templateUrl: './data-category-chips.component.html',
  styleUrls: ['./data-category-chips.component.scss'],
  standalone: false,
})

export class DataCategoryChipsComponent implements OnInit, OnChanges {
  @Input() categories: DataCategory[] = [];
  @Input() selectedCategoryIds: string[] = [];
  @Input() maxSelections: number = 2;
  @Output() selectionChanged = new EventEmitter<string[]>();

  visibleCategories: DataCategory[] = [];

  ngOnInit() {
    this.updateVisibleCategories();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.updateVisibleCategories();
  }

  /**
   * toggle selection of a data category
   * @param category 
   */
  toggleCategory(category: DataCategory) {
    const index = this.selectedCategoryIds.indexOf(category.id);

    if (index > -1) {
      // category is already selected, deselect it
      // copy array to trigger change detection if needed, or emit new array
      const newSelections = [...this.selectedCategoryIds];
      newSelections.splice(index, 1);
      this.selectedCategoryIds = newSelections;
    } else if (this.selectedCategoryIds.length < this.maxSelections) {
      // category is not selected and we have not reached the max
      this.selectedCategoryIds = [...this.selectedCategoryIds, category.id];
    }

    this.updateVisibleCategories();
    this.selectionChanged.emit(this.selectedCategoryIds);
  }

  /**
   * check if a category is selected
   * @param category 
   * @returns true if the category is selected
   */
  isSelected(category: DataCategory): boolean {
    return this.selectedCategoryIds.includes(category.id);
  }

  /**
   * update the list of visible categories
   */
  private updateVisibleCategories() {
    this.visibleCategories = this.categories || [];
  }

  /**
   * get the selected categories
   * @returns array of selected categories
   */
  getSelectedCategories(): DataCategory[] {
    return this.categories.filter(c => this.selectedCategoryIds.includes(c.id));
  }

  /**
   * check if the maximum number of categories (2) have been selected
   */
  isMaxSelectionsReached(): boolean {
    return this.selectedCategoryIds.length >= this.maxSelections;
  }
}
